<!-- 点众渠道 -->
<template>
<div>
	<!-- 标题 -->
	<div :style="{'width': table_scroll_width + 'px'}" style="position: relative;">
		<div :style="{'width': body_width + 'px'}" style="position: sticky;left: 30px;z-index: 5;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 0 0 15px;position: sticky;left: 30px;z-index: 5;">
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">点众渠道号</div>
				<a-input v-model="r_dianz_channel_id" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<div class="screen-box" style="margin-bottom:0;">
				<div class="screen-label">优化师</div>
				<a-input v-model="r_dianz_toushou" allowClear placeholder="请输入" style="width: 200px;"/>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
			<a-button @click="addButton" style="background-color: #67c23a;border-color: #67c23a;" type="primary">新增渠道</a-button>
		</div>
		</div>
	</div>
	
	<!-- 表头 -->
	<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
		<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
			<div class="table-th-cell" style="cursor: default;" 
			:style="{'width':rableTitle[0].width + 'px'}" >
				{{rableTitle[0].title}}
				
			</div>
			<div class="table-th-cell" style="cursor: default;"
			:style="{'width':rableTitle[1].width + 'px'}" >
				{{rableTitle[1].title}}
			</div>
			
		</div>
		
		<div  v-for="(item,index) in rableTitle" :key="index" >
		
			<div v-if="index > 1" class="table-th-cell" 
			:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
			>
				{{item.title}}
				<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
					<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
					<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
				</div>
			</div>
		</div>
		<!-- 占位，隔出一个空白区域 -->
		<div id="" style="padding:15px;"></div>
	</div>
	
	
	
	<!-- 表格内容 -->
	<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
		<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
			
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.id}}
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					{{item.dianz_channel_id}}
				</div>
			
		</div>
		
		<!-- 点众渠道名称 -->
		<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
			{{item.dianz_channel_name}}
		</div>
		<!-- 点众账户 -->
		<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
			{{item.dianz_account}}
		</div>
		<!-- 优化师 -->
		<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
			{{item.dianz_toushou}}
		</div>
		
		
		
	</div>
	
	
	<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
		<a-icon style="font-size: 70px;color: #999;" type="file-search" />
		
		<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
	</div>
	
	
	<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
	

	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}">
		<div style="text-align: center;margin-top: 30px;position: sticky;left: 30px;" :style="{'width': table_null_width + 'px',}">
			<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" :showTotal="(total, range) => `共 ${total} 条`" @change="paginationChange" />
		</div>
	</div>
	
	<!-- 新增/编辑的侧边栏 -->
	<a-drawer
	  title="新增点众渠道"
	  width="550px"
	  placement="right"
	  :closable="false"
	  :visible="visible"
	  @close="onCloseDrawer"
	>
		<div style="padding: 10px;">
			<div class="form-cell-box">
				<div class="class-title">点众渠道号<span class="required-hint">*</span></div>
					
				<a-input v-model="x_dianz_channel_id" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">点众渠道名称<span class="required-hint">*</span></div>
					
				<a-input v-model="x_dianz_channel_name" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">点众账户<span class="required-hint">*</span></div>
					
				<a-input v-model="x_dianz_account" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="form-cell-box">
				<div class="class-title">优化师<span class="required-hint">*</span></div>
					
				<a-input v-model="x_dianz_toushou" placeholder="请输入" style="width: 300px;"  />
			</div>
			
			<div class="form-cell-box" style="margin-top: 30px;padding-left: 41px;">
				<a-button @click="addRequest" :loading="add_button_loading" type="primary" style="margin-right: 20px;">确认</a-button>
				<a-button @click="onCloseDrawer">取消</a-button>
			</div>
		</div>
	
	</a-drawer>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { dzLinkList, dzLinkAdd  } from '@/request/api'
export default {
	name: 'putLinkDz_',
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"ID",width:110, sort_status:0, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"点众渠道号",width:210, sort_status:0, type:"dianz_channel_id",},
				{title:"点众渠道名称",width:390, sort_status:0, type:"dianz_channel_name", },
				{title:"点众账户",width:180, sort_status:0, type:"dianz_account", },
				{title:"优化师",width:180, sort_status:0, type:"dianz_toushou", },
				
				
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1800, // body的宽度
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			table_total: 0, // 表格内容总数
			r_limit: 50,
			r_page: 1,
			
			visible: false,
			
			r_dianz_channel_id: "", // 点众渠道号
			r_dianz_toushou: "", // 优化师
			
			visible: false,
			add_button_loading: false, // 新增侧边栏的确认按钮加载状态
			add_form_hint: "", // 侧边栏新增表单的验证提示
			
			x_dianz_channel_id: "", // 点众渠道号
			x_dianz_channel_name: "", // 点众渠道名称
			x_dianz_account: "", // 点众账户
			x_dianz_toushou: "", // 优化师
		}
	},
	mounted(){
		let that = this
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		setTimeout(()=>{
			// 给母页面的tab传递粘性定位用的参数
			that.$bus.$emit("stickyData", that.table_scroll_width);
		},300)
		
		// 修改母页面的tab选中状态
		// setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		// },100)
		
		that.searchButton()
		
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			let r_data = {
				limit: that.r_limit,
				page: that.r_page,
				
				dianz_channel_id: that.r_dianz_channel_id,
				dianz_toushou: that.r_dianz_toushou,
			}
			
			dzLinkList(r_data).then(res=>{
				console.log("搜索结果",res)
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.search_button_loading = false
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
					
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
				setTimeout(()=>{
					document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
				},100)
				
			}).catch(err=>{
				console.log(err)
				that.$message.error("搜索失败，可能是网络出现问题");
			})
		},
		
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		
		
		
		// 分页的页数变化
		paginationChange(e){
			console.log(e)
			this.searchButton()
		},
		
		// 新增渠道按钮
		addButton(){
			this.visible = true
		},
		addRequest(){
			let that = this
			if(!that.x_dianz_channel_id){
				this.$message.warning('点众渠道号不能为空');
			}
			else if(!that.x_dianz_channel_name){
				this.$message.warning('点众渠道名称不能为空');
			}
			else if(!that.x_dianz_account){
				this.$message.warning('点众账户不能为空');
			}
			else if(!that.x_dianz_toushou){
				this.$message.warning('优化师不能为空');
			}
			else {
				that.add_button_loading = true
				dzLinkAdd({
					dianz_channel_id : that.x_dianz_channel_id,
					dianz_channel_name : that.x_dianz_channel_name,
					dianz_account : that.x_dianz_account,
					dianz_toushou : that.x_dianz_toushou,
				}).then(res=>{
					console.log("新增渠道",res);
					that.add_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.onCloseDrawer()
						that.$message.success('新增成功');
						that.searchButton()
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`其他错误：${res.data.msg}`);
						}
					}
					
				})
			}
			
		},
		onCloseDrawer(){
			if(this.add_button_loading){
				return
			}
			
			this.visible = false
			this.x_dianz_channel_id = "" // 点众渠道号
			this.x_dianz_channel_name = "" // 点众渠道名称
			this.x_dianz_account = "" // 点众账户
			this.x_dianz_toushou = "" // 优化师
		}
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){
			// console.log("过滤器",value)
			let v = Number(value)
			return v.toFixed(2)
		}
	}
}
</script>

<style scoped>
.class-title {
	width: 100px;
}
</style>